import { render } from "./Navbar.vue?vue&type=template&id=77b71c9f"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=77b71c9f&lang=css"
script.render = render

export default script